import { useSheetStore } from '@/shared/stores/sheet-store';

export function useSessionId(): string {
    const sessionId = useSheetStore((state) => {
        const sheet = state.currentSheet;
        if (sheet?.type !== 'sessions/details') return null;
        return sheet.data?.id ?? null;
    });

    if (!sessionId) {
        throw new Error('useSessionId must be used when the sessions/details sheet is open.');
    }

    return sessionId;
}
